module.exports = __webpack_public_path__ + "img/Ooops.659f0920.png";